import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import { SwiperSlide } from 'swiper/react';

import IBimageFootplantprojection1 from '@/pages/ReportV2/components/Modals/assets/IBimageFootplantprojection1.png';
import IBimageFootplantprojection2 from '@/pages/ReportV2/components/Modals/assets/IBimageFootplantprojection2.png';
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

import { VerticalSwiper } from '@/components/swiper';

export const ProjectionFootplantModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='11' size-lg='6' size-xl='6'>
                <div>
                  <IonImg class={styles.avatar} src={IBimageFootplantprojection1} />
                </div>
              </IonCol>
              <IonCol size='11' size-lg='5' size-xl='5'>
                <div>
                  At midstance the body must respond to the maximum amount of forces it is exposed to throughout the
                  gait cycle. The best way to deal with these forces, is when the leg is directly under the body (or
                  slightly behind);
                  <br></br>
                  <br></br>
                  The resultant vector of the leg position and ground reaction force (GRF) point in the same direction
                  of the leg, optimizing the conditions for generating maximum forward propulsion force.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow class='ion-justify-content-center ion-align-items-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='11' size-lg='6' size-xl='6'>
                <div>
                  <IonImg class={styles.avatar} src={IBimageFootplantprojection2} />
                </div>
              </IonCol>
              <IonCol size='11' size-lg='5' size-xl='5'>
                <div>
                  A forward pointing leg at midstance has some far-reaching consequences. In this scenario the hip is
                  not extending. This means that the <i>m. gluteus maximus</i> is inactive. Without this anchor there
                  will not be enough tension in the knees or hips and load on these joints will increase.
                  <br></br>
                  <br></br>
                  In addition the resultant vector of the leg position and GRF will point forward. This results in a
                  breaking effect.
                  <br></br>
                  <br></br>
                  The combination of less protective tension and greater impinging force inevitably leads to less
                  control, loss of performance and increased risk of injury.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
